import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const routes = [
  //重定向
  {
    path: "/",
    redirect: "/home",
  },
  // 主页
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/index.vue"),
  },
  //实验室概况
  {
    path: "/about",
    name: "about",
    component: () => import("../views/about/index.vue"),
  },
  //学术团队
  {
    path: "/team",
    name: "team",
    component: () => import("../views/team/index.vue"),
  },
  //团队详情
  {
    path: "/team/detail/:id",
    name: "Resume",
    component: () => import("../views/team/detail.vue"),
  },
  //科研成果
  {
    path: "/research",
    name: "research",
    component: () => import("../views/research/index.vue"),
  },
  //实验室资源
  {
    path: "/resources",
    name: "resources",
    component: () => import("../views/resources/index.vue"),
  },
  //招生与就业
  {
    path: "/recruitment",
    name: "recruitment",
    component: () => import("../views/recruitment/index.vue"),
  },
  //联系我们
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact/index.vue"),
  },
  //通知详情
  {
    path: "/notice/detail/:id",
    name: "noticeDetail",
    component: () => import("../views/notice/detail.vue"),
  },
];

export default new Router({
  routes,
});
